<template>
  <div>
    <CRow class="m-1">
      <CCol col="3">
        <date-picker
            :label="$t('components.startDate')"
            v-model="start_date"></date-picker>
      </CCol>
      <CCol col="3">
        <date-picker
            :label="$t('components.endDate')"
            v-model="end_date"></date-picker>

      </CCol>
      <CCol col="2">
        <CButton size="sm" @click="get_all_data()" color="secondary">
          {{$t('search')}}
        </CButton>
      </CCol>
      <CCol col="2">
        <CButton :disabled="!selected_factors_for_status.length" @click="change_status_modal=true" type="submit" size="sm" color="secondary">
          {{$t('dialogs.ok')}}
        </CButton>
      </CCol>

    </CRow>


    <CDataTableFixed
        :items="exit_delivery_product_inventory_items"
        :fields="exit_factors_inventory_fields"
        striped
        border
        height="300px"
        :checkbox_ids.sync="selected_factors_for_status"
        :checkbox="true"
        checkbox_key="id"
        column-filter
        sorter
        :items-per-page="200"
        hover
        pagination
    >

      <template #row="{item}">

        <td style="text-align: center">
          <p >{{ item.row_id + 1 }}</p>

        </td>

      </template>
      <template #createdAt="{item}">

        <td>
          <p >{{ item.createdAt }}</p>

        </td>

      </template>
      <template #status="{item}">
        <td>
          <p v-if="item.statusTitle!=null">{{ item.statusTitle }}</p>

        </td>

      </template>
      <template #customer="{item}">

        <td>
          <p >{{ item.partyName }}</p>

        </td>

      </template>
      <template #operation="{item}">
        <td>

          <CButton
              class="m-1"
              color="primary"
              variant="outline"
              square
              :title="$t('buttons.show')"
              size="sm"
              @click="goShowDocument(item)"
          >
            <CIcon name="cil-speedometer"/>
          </CButton>


        </td>
      </template>

    </CDataTableFixed>

    <CModal
        :show.sync="change_status_modal"
        :no-close-on-backdrop="true"
        color="transparent"
        border-color="primary"
        size="sm"
        :title="$t('components.changeStatus')"
    >

      <CRow>
        <CCol col="12">
          <CSelect
              :label="$t('inventory')"
              horizontal
              :options="places_items"
              :value.sync="selected_place"
          />
          <CSelect :options="filtered_accounting_list" :label="$t('moein')"
                   horizontal
          />
          <CInput
              :label="$t('components.summary')"
              horizontal
              v-model="change_status_summary"
          />


        </CCol>
      </CRow>
      <template #footer>
        <CButton @click="change_status_data(0)"
                 color="success"
        >{{ $t("buttons.ok") }}
        </CButton>
        <CButton
            @click="change_status_modal = false"
            color="danger"
        >{{ $t("buttons.cancel") }}
        </CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import moment from 'moment-jalaali'

var items = [];


export default {
  name: 'Login',
  components: {

  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,

      start_date: '',
      end_date: '',
      change_status_modal: false,
      selected_factors_for_status: [],
      selected_status: 0,

       change_status_summary: '',

      places_items:[],
      selected_place:0,

      exit_delivery_product_inventory_items: [],
      all_accounting_list:[],
      filtered_accounting_list:[],

      exit_factors_inventory_fields: [
        {key: 'productName', label: this.$t('components.productName'), _style: 'width:20%'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'width:10%'},
        // {key: 'userName', label: this.$t('orderBy'), _style: 'width:20%'},
        // {key: 'masterCode', label: this.$t('requestId'), _style: 'width:10%'},
        // {key: 'summary', label: this.$t('tables.summary'), _style: 'width:20%'},
        // {key: 'select', label: this.$t('tables.select'), _style: 'width:2%'},

      ],


      status_form: 0,
      check_all_exit: false,

    }
  },
  mounted() {
    this.start_date = this.get_day_before_today(1);
    this.end_date = this.get_today();

    this.$root.root_validate_errors = [];
    bus.$on('update_orders', (data) => {
      this.get_all_data()
    });

    this.get_all_data();
    this.get_places();
    this.get_lists_groups();


  }, watch: {

    'start_date': function () {
      this.get_all_data();
    },
    'end_date': function () {
      this.get_all_data();
    },

  },
  methods: {
    get_places() {
      var self = this;
      self.places_items = [];
      this.$apis.get_places().then(result =>{
        self.places_items = result
        self.selected_place = self.places_items[0].value;

      })

    },
    check_all() {
      console.log('check all clicked');
    },
    goShowDocument(item) {

      this.$router.push({path: '/dashboard/documents/show/' + item.recId});
    },
    change_status_data(index) {
      if (this.selected_status == 0) {
        return false;
      }
      if(this.selected_factors_for_status.length==0){
        return false;

      }
      this.change_status_modal = false;
      var self = this;

      const formData = new FormData();

      formData.append('FactorId', this.selected_factors_for_status[index]);
      formData.append('StatusId', this.selected_status);


      axios.post('AddFactorStatus', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          if(self.selected_factors_for_status.length - 1< index){
            self.change_status_data(index+1);
          }else{
            self.get_all_data();
            self.selected_factors_for_status = []
          }


        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });
    },
    get_lists_groups() {
      var self = this;
      self.items_parent = [];
      self.data_with_children = []

      const formData = new FormData();
      var url = "Get_AllAccountingGroups";
      // formData.append("MasterId", 0);

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {


              self.all_accounting_list = response.data.data


              // console.log(self.data);
              response.data.data.forEach((val) => {
                if (val.parentId == 11) {

                  var obj = {
                    label: val.accountName,
                    name_code: val.accountName + " (" + val.accountCode + ")",
                    nature: val.nature,
                    type: val.type,
                    code: val.accountCode,
                    parentId: val.parentId,
                    value: val.id,
                    // children: self.get_childrens(val.id, response.data.data)


                  }

                  self.filtered_accounting_list.push(obj);


                }

              });
              // self.filter_data()
            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      )
          .catch(function (error) {
            console.log(error);
          });

    },

    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' && this.color != '') {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      if (this.color == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertColor'));
      }
      // if (this.description == '') {
      //   this.$root.root_validate_errors.push(this.$t('dialogs.insertSummary'));
      // }
      return false;
      // e.preventDefault();
    },
    get_all_data(){
      this.get_insite_lists()
    },


    get_insite_lists() {
      var self = this;

      const formData = new FormData();

      formData.append('Id', 2);


      axios.post('GetAcceptPurchaseReq', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.exit_delivery_product_inventory_items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },

    insert_data() {


      if (!this.validateForm()) {
        // console.log("validate form is false"+this.validate_errors);
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddMainCat";
      } else {
        url = "EditMainCat";
        formData.append('id', this.status_form)

      }

      formData.append('file', this.file);
      formData.append('MainCatTitle', this.name);
      formData.append('Color', this.color);
      formData.append('Code', this.code);
      if (this.$route.params.cat_id != null) {
        formData.append('IsParent', this.$route.params.cat_id);

      } else {
        formData.append('IsParent', 0);

      }
      formData.append('summary', this.description);
      axios.post(url, formData, {}).then((res) => {



        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;
        self.name = '';
        self.color = '#ffffff';
        self.code = '';
        self.description = '';
        self.previewImage = '/img/placeholder.png';
        self.get_all_data();


      })

          // axios.post(  '/admin/category', {
          //     name: self.name,
          //     description: self.description,
          //     image: self.image,
          //     cat: 0,
          // }).then(function (response) {
          //     self.name = '';
          //     self.description = '';
          //     // localStorage.setItem("api_token", response.data.access_token);
          //     // self.$router.push({ path: 'notes' });
          // })
          .catch(function (error) {
            console.log(error);
          });

    },

  }
}

</script>
